<template>
  <div>
    <div>
      <adicionar-imagem v-if="show.showAdicionarImagem"
                        :prop-habilitacao="propHabilitacao"
                        :prop-documentos="documentos"
                        :prop-tipo-documento="propTipoDocumento"
                        :prop-tab="propTab"
                        @onShowLista="(status) => showLista(status)"
                        @onCancel="show.showAdicionarImagem = !show.showAdicionarImagem"
                        @onNewImage="documents => newImage(documents)" />
    </div>

    <div class="mt-2">
      <visualizar-imagem v-if="show.documentosLista"
                         :prop-documentos="documentos"
                         @onEditDoc="doc => editDoc(doc)"
                         @onDeleteDoc="doc => deleteDoc(doc)" />
    </div>
  </div>
</template>

<script>
  /* components */
  import AdicionarImagem from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso/AdicionarImagem"
  import VisualizarImagem from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso/VisualizarImagem"

  /* libraries */
  import moment from 'moment'

  export default {
    name: "PrepararProcesso",
    components: {
      AdicionarImagem,
      VisualizarImagem
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => ({})
      },
      propDocumentos: {
        type: Array,
        default: () => []
      },
      propTipoDocumento: {
        type: String,
        default: () => null
      },
      propTab: {
        type: Number,
        default: () => 0
      }
    },
    data () {
      return {
        show: {
          showAdicionarImagem: true,
          documentosLista: false
        },
        documentos: []
      }
    },
    watch: {
      propDocumentos () {
        this.init()
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        // se ja existir documentos ira ser mostrado a visualizacao
        if (this.propDocumentos.length > 0) {
          this.show.documentosLista = true
        } else {
          this.show.documentosLista = false

          if (['habilitar_casamento'].indexOf(this.$route.name) != -1) {
            this.show.showAdicionarImagem = true
          }
        }

        if (['resumo_habilitacao_casamento', 'editar_habilitacao_casamento'].indexOf(this.$route.name) != -1) {
          this.show.documentosLista = true
          this.show.showAdicionarImagem = true
        }

        let documentos = []

        if (this.propHabilitacao.gerar_autuacao) {
          documentos = this.propDocumentos.filter(doc => doc.tag == 'processo_autuacao_sofia')
          const autuacao = documentos[0]
          documentos.push(...this.propDocumentos.filter(doc => (this.countDiff(doc.created_at, autuacao.created_at, 'seconds') > 0 && !doc.tag.match('_sofia') || (!doc.tag.match('_sofia') && !doc.habilitacao_casamento_documento_id))))
        } else {
          documentos = this.propDocumentos.filter(doc => ['processo_autuacao_sofia', 'processo_autuacao_assinado_sofia'].indexOf(doc.tag) == -1 && !doc.tag.match('_sofia') || (!doc.tag.match('_sofia') && !doc.habilitacao_casamento_documento_id))
        }



        this.documentos = documentos

        /**
         * Quando o tipo de casamento for afixação de edital não existe o passo
         * impressão de peças, por isso diminuimos o número do passo atual
         */
        let passo = 4

        let docs = null
        if (this.propTipoDocumento === 'Afixação de edital de outra serventia') {
          docs = this.propDocumentos.find(document => document.obrigatorio == true && document.label == "Edital")
          passo = 3
        } else {
          docs = this.propDocumentos.find(document => document.obrigatorio == true && document.label == "Memorial")
        }

        if (docs || this.propHabilitacao.gerar_autuacao) {
          this.$emit('onActive', true, passo)
        } else {
          this.$emit('onActive', false, passo)
        }
      },
      countDiff (dataInicial = null, dataFinal = null, type = 'days') {
        if (!dataInicial) {
          dataInicial = moment(new Date()).format('YYYY-MM-DD')
        }

        if (!dataFinal) {
          dataFinal = moment(new Date()).format('YYYY-MM-DD')
        }

        return moment(dataInicial).diff(dataFinal, type)
      },
      deleteds (deleteds = null) {
        if (deleteds !== null) {
          this.$emit('onDeleteds', deleteds)
        }
      },
      newImage (documents) {
        this.$emit('onNewDocument', documents)
        /*this.show.showAdicionarImagem = false;
        if (this.show.documentosLista == false) {
          this.show.documentosLista = true;
        }*/
      },
      editDoc (doc) {
        this.$emit('onEditDoc', doc)
      },
      deleteDoc (doc) {
        this.show.showAdicionarImagem = false
        this.$emit('onDeleteDoc', doc)

        let deleteds = null

        if (doc && doc.habilitacao_casamento_documento_id) {
          deleteds = {
            habilitacaoDocumentos: doc.habilitacao_casamento_documento_id
          }
        }

        setTimeout(() => {
          this.deleteds(deleteds)
          this.init()
        }, 100)
      },

      showLista (status) {
        this.show.documentosLista = status
      }
    }
  }
</script>

<style scoped>

</style>
